import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../../maps/data.js"; // Assuming API is used to fetch data
import ShelfView from "./shelf-view.js"; // Import the ShelfView component
import { Card, CardContent } from "@mui/material";
import DropdownWithCheckboxes from "./../../components/ui/DropdownWithCheckboxes";

const FieldDetailPage = () => {
  // debugger
  const { id, edgeId } = useParams(); // Get the field id from the URL
  const navigate = useNavigate();

  const [fieldData, setFieldData] = useState(null);
  const [fields, setFields] = useState(null);

  const [products, setProducts] = useState(null);
  const [totalProductsCount, setTotalProductsCount] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Function to fetch field data
  const fetchFieldData = async () => {
    setError(null);
    try {
      const res = await api({
        type: "getFieldswithPlacements",
        data: {
          siteId: edgeId,
        },
        disableBI: true,
      });
      setFields(
        res.map((field) => {
          return {
            name: field.name,
            id: field._id,
          };
        })
      );

      // Parse the IDs from the route
      const selectedIds = id.split(",");

      // Filter data for the selected IDs
      const filteredFields = res.filter((field) =>
        selectedIds.includes(field._id)
      );

      setFieldData(filteredFields);

      const productIds = new Set(); // Use a Set to store unique IDs
      const layers = [];
      res.forEach((field) => {
        field.shelves.forEach((shelf) => {
          shelf.planogram.forEach((planogramItem) => {
            productIds.add(planogramItem.productId);

          });
        });
        // Also extract from placements within sensorArr
        field.sensorArr.forEach((sensor) => {
          sensor.placements.forEach((placement) => {
            layers.push(...placement.layers);
            productIds.add(placement.productId);
          });
        });
      });
      const totoalProductCount = {};

      // Iterate over the array and count occurrences of each productId
      layers.forEach((item) => {
        if (totoalProductCount[item.productId]) {
          totoalProductCount[item.productId]++;
        } else {
          totoalProductCount[item.productId] = 1;
        }
      });
      // console.log("productIds", productIds)
      // debugger

      setTotalProductsCount(totoalProductCount);
      const productsRes = await api({
        type: "getProducts",
        data: {
          productIds: Array.from(productIds),
          ignoreCategory: true,
          page: 0,
          disableBI: true,

        }
      }).then(({ products }) => {
        const temp = {};
        const productsById = {};
        for (let i = 0; i < products.length; i++) {
          const product = products[i];
          temp[product.barcode] = product;
          productsById[product._id] = product;
        }
        setProducts({ ...productsById });
      });
    } catch (err) {
      console.error("Failed to fetch field data:", err);
      setError("Unable to fetch field data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch data on mount and refresh every 2 seconds
  useEffect(() => {
    fetchFieldData(); // Initial fetch

    const interval = setInterval(() => {
      fetchFieldData(); // Fetch data every 2 seconds
    }, 2000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [id, edgeId]); // Dependencies to refetch if `id` or `edgeId` changes

  if (loading) {
    return (
      <div className="flex justify-center items-center flex-col space-y-2">
        <div className="animate-spin rounded-full border-4 border-t-4 border-gray-500 w-16 h-16"></div>
        <p className="text-lg">Loading Field Details...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center text-red-500">
        <p className="text-lg">{error}</p>
      </div>
    );
  }

  if (!fieldData) {
    return (
      <div className="text-center">
        <p className="text-lg">No field data found</p>
      </div>
    );
  }

  // Check if products is not null or empty before rendering shelves
  if (!products || Object.keys(products).length === 0) {
    return (
      <div className="text-center">
        <p className="text-lg">No product data available</p>
      </div>
    );
  }
  return (
    <div className="flex flex-wrap">
      {/* <div className="p-8">
         
        <DropdownWithCheckboxes fields={fields} />
      </div> */}
      {fieldData.map((field) => (
        <div
          key={field._id}
          className={`p-2 ${fieldData.length === 1 ? "w-full" : "w-1/2"}`}
        >
          <h2 className="text-xl font-semibold mb-4">{field.name}</h2>

          <div className="w-full  ">
            {field.shelves &&
              field.shelves.map((shelf) => (
                <ShelfView
                  key={shelf._id}
                  shelf={shelf}
                  sensor={field.sensorArr.filter(
                    (sensor) => sensor._id === shelf.sensorId
                  )}
                  products={products}
                  productsCount={totalProductsCount}
                />
              ))}

            {/* You can also render camera positions here */}
          </div>
        </div>
      ))}
    </div>
    //  (
    //   <div className="px-8 py-4 min-h-screen" style={{display:'none'}}>
    //     <h2 className="text-4xl text-center mb-4">{fieldData.name}</h2>

    //     {/* Here you can render the global visual of the field */}
    //     <div className="flex justify-center h-[1500px] overflow -y-auto ">
    //       <div className="w-full h-[260px]">
    //         {fieldData.shelves &&
    //           fieldData.shelves.map((shelf) => (
    //             <ShelfView
    //               key={shelf._id}
    //               shelf={shelf}
    //               sensor={fieldData.sensorArr.filter(
    //                 (sensor) => sensor._id === shelf.sensorId
    //               )}
    //               products={products}
    //               productsCount={totalProductsCount}
    //             />
    //           ))}

    //         {/* You can also render camera positions here */}
    //       </div>
    //     </div>
    //   </div>
    // )
  );
};

export default FieldDetailPage;
